// A localized long date like "jeu. 16 juil. 2026" (weekday + day + month +
// year) from a JS Date, for the assignment timing rows.
const displayLongDate = (date, lang = 'fr') => {
  if (!date) return '';
  return new Intl.DateTimeFormat(
    lang,
    {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    },
  ).format(date);
};

export default displayLongDate;
